module.exports = __webpack_public_path__ + "img/bud-tedector-with-all-box.cfbe0a81.jpg";